const ProductApplications = {
    valid_doses: {
        cc: "cc/L",
        L: "cc/L",
        kg: "g/L"
    }
}

export default ProductApplications
